// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1o6oMi8gFnHuq2or7aU4o4{display:flex;flex-direction:column;padding:3.2rem 2.4rem}@media only screen and (min-width:768px){._1o6oMi8gFnHuq2or7aU4o4{justify-content:space-between;flex-direction:row}}@media only screen and (min-width:1200px){._1o6oMi8gFnHuq2or7aU4o4{flex-direction:column}}.u6im5uGgS6ba95Y3QMPrg,.uP6zEKy54-bJcYvPwsgdm{flex-basis:45%}.E2a-fkOSe-avTnezRo4GU{margin-top:3rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_1o6oMi8gFnHuq2or7aU4o4",
	"charactesticsBloc": "u6im5uGgS6ba95Y3QMPrg",
	"statsWrapper": "uP6zEKy54-bJcYvPwsgdm",
	"stats": "E2a-fkOSe-avTnezRo4GU"
};
module.exports = ___CSS_LOADER_EXPORT___;
